module.exports = __webpack_public_path__ + "c83cca7eca5b349e4919b04e0e866106.svg";